import { Component, Input, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

// eslint-disable-next-line no-var
declare var google: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Input()
  siteUpdateDate: Date | undefined;
  lastUpdated = "September 1, 2023";
  isMobileLayout = false;

  ngOnInit(): void {
    // console.log("HeaderComponent");

    try {
      //this.loadGoogleTranslate();
      this.initializeTranslator();
      this.preventRedirectOnClick();
      this.applyStylesToTranslateIframe();
    } catch (error) {
      console.log(error);
    }
  }
  applyStylesToTranslateIframe() {
    const interval = setInterval(() => {
      const iframe = document.querySelector(
        "iframe[title^='Language Translate Widget']",
      ) as HTMLIFrameElement;
      if (iframe) {
        iframe.style.width = "100%";
        iframe.style.height = "280px";

        const iframeBody = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeBody) {
          const iBody = iframeBody.body;
          iBody.style.overflow = "auto";
        }
        clearInterval(interval);
      }
    }, 1500);
  }

  initializeTranslator(): void {
    const initWidget = () => {
      // Prevent duplicate widget
      if (document.querySelector(".goog-te-combo")) {
        return;
      }

      if ((window as any).google && (window as any).google.translate) {
        new (window as any).google.translate.TranslateElement(
          {
            pageLanguage: "en",
            layout:
              window.innerWidth > 500
                ? (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE
                : (window as any).google.translate.TranslateElement.InlineLayout.VERTICAL,
            autoDisplay: false,
          },
          "google_translate_element",
        );
      }
    };

    // Assign callback used by Google
    (window as any).initGoogleTranslateWidget = initWidget;

    // Fallback: if Google already loaded, retry until available
    const interval = setInterval(() => {
      if ((window as any).google && (window as any).google.translate) {
        initWidget();
        clearInterval(interval);
      }
    }, 500);
  }

  preventRedirectOnClick(): void {
    document.getElementById("google_translate_element")?.addEventListener("click", (event) => {
      event.preventDefault();
    });
    this.isMobileLayout = window.innerWidth < 500;
  }

  printPDF(): void {
    window.print();
  }
}
